import { WarningIcon } from '../icons/support.tsx'
import { Card } from './Card.tsx'

interface ErrorCardProps {
  title?: string
  text?: string
}

const ErrorCard = ({
  title = 'Error',
  text = 'There was an error. If the issue persists, contact support. ',
}: ErrorCardProps) => {
  return (
    <div className="h-full w-full flex items-center justify-center">
      <Card className="divide-y-0 p-4 flex flex-col items-center justify-center min-h-60 min-w-80 space-y-6">
        <WarningIcon className="text-red-500 text-4xl" />
        <div className="flex flex-col items-center justify-center space-y-2">
          <h3 className="text-gray-900 text-xl font-medium text-center">
            {title}
          </h3>
          {text && (
            <p className="text-gray-600 text-base text-center">{text}</p>
          )}
        </div>
      </Card>
    </div>
  )
}

export { ErrorCard }
